import { Email } from "../../../../src/components/Email";
import * as React from 'react';
export default {
  Email,
  React
};